// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   HOME PAGE DESIGN SYSTEM - Lovable & Modern
   ========================================= */

:root {
    /* --- Default Dark Theme Variables --- */

    /* Backgrounds */
    --bg-gradient: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%);
    --bg-mesh-1: rgba(120, 119, 198, 0.15);
    --bg-mesh-2: rgba(67, 56, 202, 0.15);

    /* Glass/Cards */
    --glass-bg: rgba(255, 255, 255, 0.03);
    --glass-border: rgba(255, 255, 255, 0.08);
    --glass-hover: rgba(255, 255, 255, 0.08);
    --dropdown-bg: rgba(30, 41, 59, 0.95);

    /* Text */
    --text-main: #ffffff;
    --text-secondary: rgba(255, 255, 255, 0.7);
    --text-muted: rgba(255, 255, 255, 0.5);
    --heading-gradient: linear-gradient(to right, #fff, #94a3b8);

    /* Inputs */
    --input-bg: rgba(255, 255, 255, 0.08);
    --input-border: rgba(255, 255, 255, 0.1);
    --input-text: #fff;
    --input-placeholder: rgba(255, 255, 255, 0.4);

    /* Accents */
    --accent-color: hsl(38, 92%, 50%);
    /* Gold/Amber */
    --primary: hsl(197, 71%, 28%);
    --decorative-circle: rgba(255, 255, 255, 0.05);

    /* Shadows */
    --shadow-card: 0 10px 30px -10px rgba(0, 0, 0, 0.5);
    --shadow-glow: 0 0 20px rgba(79, 70, 229, 0.15);
}

/* --- Light Theme Variables --- */
[data-theme='light'] {
    /* Bright, Attracting Gradient: Soft Warmth + Fresh Air */
    --bg-gradient: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
    /* Clean Cloud */
    /* Alternative "Attracting" Mesh colors */
    --bg-mesh-1: rgba(255, 165, 0, 0.1);
    /* Soft Orange */
    --bg-mesh-2: rgba(0, 191, 255, 0.1);
    /* Sky Blue */

    /* Glass/Cards - Darker glass on light bg */
    --glass-bg: rgba(255, 255, 255, 0.7);
    /* Frosted White */
    --glass-border: rgba(0, 0, 0, 0.12);
    --glass-hover: rgba(255, 255, 255, 0.9);
    --dropdown-bg: rgba(255, 255, 255, 0.95);

    /* Text */
    --text-main: #1e293b;
    /* Slate 800 */
    --text-secondary: #475569;
    /* Slate 600 */
    --text-muted: #94a3b8;
    /* Slate 400 */
    --heading-gradient: linear-gradient(to right, #0f172a, #334155);

    /* Inputs */
    --input-bg: rgba(255, 255, 255, 0.8);
    --input-border: rgba(0, 0, 0, 0.1);
    --input-text: #0f172a;
    --input-placeholder: #94a3b8;

    /* Accents */
    --accent-color: hsl(38, 95%, 45%);
    /* Slightly darker gold for contrast */
    --primary: hsl(197, 71%, 35%);
    --decorative-circle: rgba(0, 0, 0, 0.03);

    /* Shadows */
    --shadow-card: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
    --shadow-glow: 0 0 15px rgba(0, 0, 0, 0.05);

    /* Specific Overrides for Icon Buttons in Light Mode */
    --btn-bg: rgba(0, 0, 0, 0.05);
    --btn-hover: rgba(0, 0, 0, 0.1);
}

/* =========================================
   LAYOUT & CONTAINER
   ========================================= */

.home-page-container {
    min-height: 100vh;
    width: 100%;
    background: var(--bg-gradient);
    color: var(--text-main);
    position: relative;
    overflow-x: hidden;
    padding-bottom: 4rem;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    transition: background 0.5s ease, color 0.3s ease;
}

/* Subtle Animated Background Mesh */
.home-page-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
        radial-gradient(circle at 15% 50%, var(--bg-mesh-1), transparent 25%),
        radial-gradient(circle at 85% 30%, var(--bg-mesh-2), transparent 25%);
    pointer-events: none;
    z-index: 0;
    transition: background 0.5s ease;
}

.home-content-wrapper {
    position: relative;
    z-index: 10;
    max-width: 1200px;
    margin: 0 auto;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
}

/* =========================================
   HEADER & NAV
   ========================================= */

.home-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
}

.brand-section {
    display: flex;
    flex-direction: column;
}

.brand-title {
    font-size: 1.5rem;
    font-weight: 800;
    letter-spacing: -0.02em;
    background: var(--heading-gradient);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.greeting-text {
    font-size: 0.9rem;
    color: var(--text-secondary);
    font-weight: 500;
}

.header-actions {
    display: flex;
    gap: 0.75rem;
}

.icon-btn {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-main);
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
}

[data-theme='light'] .icon-btn {
    background: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.icon-btn:hover {
    background: var(--glass-hover);
    transform: translateY(-2px);
}

.notification-badge {
    position: absolute;
    top: -2px;
    right: -2px;
    width: 10px;
    height: 10px;
    background: #ef4444;
    border-radius: 50%;
    border: 2px solid var(--background, #1a1a2e);
    /* Fallback */
}

/* Notif Dropdown */
.notifications-dropdown {
    position: absolute;
    top: 105%;
    right: 0;
    width: 300px;
    background: var(--dropdown-bg);
    backdrop-filter: blur(12px);
    border: 1px solid var(--glass-border);
    border-radius: 16px;
    padding: 1rem;
    box-shadow: var(--shadow-card);
    z-index: 100;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    color: var(--text-main);
}

.notif-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.8rem;
    background: var(--glass-bg);
    border-radius: 8px;
    font-size: 0.9rem;
}

.btn-accept {
    background: var(--primary);
    border: none;
    color: white;
    padding: 0.4rem 0.8rem;
    border-radius: 6px;
    font-size: 0.8rem;
    cursor: pointer;
}

/* =========================================
   SEARCH SECTION
   ========================================= */

.search-section {
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 50;
}

.search-pill-container {
    width: 100%;
    max-width: 600px;
    position: relative;
}

.search-input-group {
    position: relative;
    display: flex;
    align-items: center;
}

.search-icon {
    position: absolute;
    left: 1.25rem;
    top: 50%;
    transform: translateY(-50%);
    color: var(--text-muted);
    pointer-events: none;
    z-index: 10;
}

.search-input-modern {
    width: 100%;
    padding: 1rem 1rem 1rem 3.5rem;
    background: var(--input-bg);
    border: 1px solid var(--input-border);
    backdrop-filter: blur(10px);
    border-radius: 10rem;
    /* Pill shape */
    color: var(--input-text);
    font-size: 1rem;
    transition: all 0.3s ease;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.search-input-modern:focus {
    background: var(--input-bg);
    border-color: var(--text-muted);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
    outline: none;
}

.search-input-modern::placeholder {
    color: var(--input-placeholder);
}

.no-results-text {
    padding: 2rem;
    text-align: center;
    color: var(--text-muted);
    font-size: 0.95rem;
    width: 100%;
    font-weight: 500;
}

/* Search Results Dropdown */
.search-results-glass {
    position: absolute;
    top: calc(100% + 12px);
    left: 0;
    right: 0;
    background: var(--dropdown-bg);
    backdrop-filter: blur(16px);
    border: 1px solid var(--glass-border);
    border-radius: 16px;
    padding: 0.5rem;
    max-height: 400px;
    overflow-y: auto;
    box-shadow: var(--shadow-card);
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    color: var(--text-main);
}

.search-result-row {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 1rem;
    border-radius: 12px;
    cursor: pointer;
    transition: background 0.2s;
    text-decoration: none;
    color: var(--text-main);
    background: transparent;
    border: none;
    width: 100%;
    font-family: inherit;
    font-size: 0.95rem;
}

.search-result-row:hover {
    background: var(--glass-hover);
}

.result-avatar-small {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--primary);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 0.9rem;
    color: white;
}

.result-info {
    display: flex;
    flex-direction: column;
}

.result-name {
    font-weight: 600;
    font-size: 0.95rem;
    color: var(--text-main);
}

.result-meta {
    font-size: 0.8rem;
    color: var(--text-muted);
}

/* =========================================
   SUGGESTIONS CAROUSEL
   ========================================= */

.suggestions-section {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.section-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: var(--text-main);
    padding-left: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

/* Standard Scrollable Suggestions which will be driven by JS for auto-scroll */
.suggestions-track-wrapper {
    position: relative;
    mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
}

.suggestions-carousel {
    display: flex;
    gap: 1rem;
    overflow-x: auto;
    padding: 1rem 0.5rem;
    scrollbar-width: none;
    cursor: grab;
    scroll-behavior: auto;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x;
}

.suggestions-carousel::-webkit-scrollbar {
    display: none;
}



.suggestion-card-modern {
    flex: 0 0 200px;
    height: 220px; /* Enforce consistent height */
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    border-radius: 16px;
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    text-decoration: none;
    position: relative;
    overflow: hidden;
}

[data-theme='light'] .suggestion-card-modern {
    background: white;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
}

.suggestion-card-modern:hover {
    background: var(--glass-hover);
    transform: translateY(-5px);
    box-shadow: var(--shadow-card);
    border-color: var(--glass-border);
}

.sugg-avatar-large {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--primary), #9333ea);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    font-weight: 700;
    color: white;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.sugg-info {
    text-align: center;
}

.sugg-name {
    font-weight: 700;
    color: var(--text-main);
    font-size: 1rem;
    line-height: 1.25;
    margin-bottom: 0.5rem;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    min-height: 2.5rem; /* Reserve space for up to two lines */
}

.sugg-dept {
    font-size: 0.8rem;
    color: var(--text-secondary);
    background: var(--glass-border);
    padding: 0.2rem 0.6rem;
    border-radius: 20px;
}

.connect-btn-mini {
    margin-top: 0.25rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--accent-color);
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

/* =========================================
   UTILITIES
   ========================================= */

.glass-card {
    background: var(--glass-bg);
    backdrop-filter: blur(12px);
    border: 1px solid var(--glass-border);
    border-radius: 20px;
    padding: 1.5rem;
    color: var(--text-main);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    position: relative;
    overflow: hidden;
}

[data-theme='light'] .glass-card {
    background: white;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

/* =========================================
   BENTO GRID FEATURES
   ========================================= */

.features-grid-bento {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.5rem;
}

@media (min-width: 768px) {
    .features-grid-bento {
        grid-template-columns: repeat(3, 1fr);
    }
}

.feature-tile {
    background: var(--glass-bg);
    backdrop-filter: blur(10px);
    border: 1px solid var(--glass-border);
    border-radius: 24px;
    padding: 2rem;
    text-decoration: none;
    color: var(--text-main);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* Center content */
    gap: 1.5rem;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    position: relative;
    overflow: hidden;
    min-height: 200px;
}

[data-theme='light'] .feature-tile {
    background: white;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
}

/* Specific styling for larger primary card if we want odd layouts, 
   but 3-col grid is clean. Let's make the "Profile" card span 2 cols on tablet */
@media (min-width: 768px) and (max-width: 1024px) {
    .feature-tile:first-child {
        grid-column: span 2;
    }
}

.feature-tile:hover {
    background: var(--glass-hover);
    transform: translateY(-5px) scale(1.02);
    border-color: var(--glass-border);
    box-shadow: var(--shadow-card);
}

.tile-icon-box {
    width: 80px;
    height: 80px;
    border-radius: 24px;
    background: linear-gradient(135deg, var(--glass-border), rgba(255, 255, 255, 0.02));
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.5rem;
    box-shadow: inset 0 0 0 1px var(--glass-border);
    transition: transform 0.3s ease;
    color: var(--text-main);
}

[data-theme='light'] .tile-icon-box {
    background: #f1f5f9;
}

.feature-tile:hover .tile-icon-box {
    transform: scale(1.1) rotate(5deg);
}

.tile-content {
    text-align: center;
}

.tile-title {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
    color: var(--text-main);
}

.tile-desc {
    font-size: 0.9rem;
    color: var(--text-secondary);
    line-height: 1.4;
}

/* Decorative Circle */
.feature-tile-bg-circle {
    position: absolute;
    top: -20%;
    right: -20%;
    width: 150px;
    height: 150px;
    background: var(--decorative-circle);
    border-radius: 50%;
    pointer-events: none;
}

/* Responsive adjustments */
@media (max-width: 640px) {
    .home-content-wrapper {
        padding: 1rem;
        gap: 2rem;
    }

    .brand-title {
        font-size: 1.25rem;
    }

    .feature-tile {
        min-height: 160px;
        padding: 1.5rem;
        flex-direction: row;
        /* Horizontal on mobile for compactness */
        justify-content: flex-start;
        text-align: left;
        align-items: center;
    }

    .tile-icon-box {
        width: 60px;
        height: 60px;
        margin-bottom: 0;
        flex-shrink: 0;
    }

    .tile-content {
        text-align: left;
    }

    .tile-desc {
        font-size: 0.85rem;
    }
}

/* =========================================
   MEMBER DOTS (Formation)
   ========================================= */
.member-dot {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background: var(--primary);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid var(--glass-border);
    transition: all 0.2s ease;
    overflow: hidden;
    color: white;
    font-weight: bold;
    font-size: 0.8rem;
}

.member-dot:hover {
    transform: scale(1.1);
    border-color: var(--accent-color);
    box-shadow: 0 0 10px rgba(59, 130, 246, 0.3);
    z-index: 10;
}

.member-dot img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.member-dot-empty {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background: transparent;
    border: 2px dashed rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.3);
}

.status-badge-open {
    background: rgba(34, 197, 94, 0.2);
    color: #22c55e;
    padding: 0.2rem 0.6rem;
    border-radius: 12px;
    font-size: 0.8rem;
    font-weight: bold;
    border: 1px solid rgba(34, 197, 94, 0.3);
}

.lead-badge {
    background: var(--accent-color);
    color: var(--background);
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 0.7rem;
    font-weight: 800;
    text-transform: uppercase;
    margin-left: 0.5rem;
}


/* =========================================
   TEAM ROOM REDESIGN (Premium Cards)
   ========================================= */
.member-info-card {
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    border-radius: 20px;
    padding: 1.5rem;
    display: flex;
    align-items: center;
    gap: 1.5rem;
    position: relative;
    transition: all 0.3s ease;
}

[data-theme='light'] .member-info-card {
    background: white;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.member-avatar-box {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    border: 3px solid var(--glass-border);
    background: var(--primary);
}

.member-avatar-box img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.rule-item {
    margin-bottom: 1.25rem;
}

.rule-label {
    font-size: 0.9rem;
    font-weight: 500;
    margin-bottom: 0.5rem;
    display: block;
}

.rule-progress {
    height: 8px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    overflow: hidden;
}

[data-theme='dark'] .rule-progress {
    background: rgba(255, 255, 255, 0.1);
}

.rule-progress-bar {
    height: 100%;
    background: var(--accent-color);
    border-radius: 10px;
    transition: width 0.5s ease;
}

.rule-item.success .rule-progress-bar {
    background: #22c55e;
}

/* =========================================
   TEAM ROOM RESPONSIVE LAYOUT
   ========================================= */
.team-room-header-stats {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4rem;
}

.team-room-grid {
    display: grid;
    grid-template-columns: 1fr 350px;
    gap: 2rem;
}

.header-card-main {
    padding: 3.5rem 2rem;
    margin-bottom: 2rem;
    text-align: center;
    border-radius: 30px !important;
}

.team-name-title {
    font-size: 4rem;
    margin-bottom: 1rem;
    line-height: 1.1;
}

.team-members-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
}

@media (max-width: 1024px) {
    .team-room-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .team-room-header-stats {
        gap: 1.5rem;
        flex-wrap: wrap;
    }

    .team-members-grid {
        grid-template-columns: 1fr;
    }

    .member-info-card {
        padding: 1rem;
        gap: 1rem;
    }

    .member-avatar-box {
        width: 60px;
        height: 60px;
    }

    /* Header refinements */
    .team-name-title {
        font-size: 1.8rem !important;
    }

    .header-card-main {
        padding: 2rem 1rem !important;
    }
}

@media (max-width: 480px) {
    .team-room-header-stats {
        gap: 1rem;
    }

    .team-room-header-stats>div {
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: calc(50% - 1rem);
    }
}

.hover-underline:hover {
    text-decoration-color: var(--accent-color) !important;
    color: var(--accent-color);
}

.hover-bg-glass:hover {
    background: rgba(255, 255, 255, 0.1);
}

[data-theme='light'] .member-dot-empty {
    border-color: rgba(0, 0, 0, 0.2);
    color: rgba(0, 0, 0, 0.4);
}

[data-theme='light'] .status-badge-open {
    background: rgba(16, 185, 129, 0.1);
    color: #059669;
    border: 1px solid rgba(16, 185, 129, 0.2);
}

/* =========================================
   DYNAMIC MULTI-COLOR GLOW SYSTEM
   ========================================= */

@keyframes glassGlow {
    0% {
        transform: translateX(-150%) skewX(-20deg);
    }

    100% {
        transform: translateX(250%) skewX(-20deg);
    }
}

.team-card-glow {
    position: relative !important;
    overflow: hidden !important;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
}

.team-card-glow::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    animation: glassGlow 6s infinite linear;
    pointer-events: none;
    z-index: 1;
    opacity: 0.6;
}

/* Base Shine Gradient Utility */
.team-card-glow::before {
    background: linear-gradient(90deg,
            transparent 0%,
            rgba(var(--glow-rgb), 0) 30%,
            rgba(var(--glow-rgb), 0.15) 50%,
            rgba(var(--glow-rgb), 0) 70%,
            transparent 100%);
}

[data-theme='light'] .team-card-glow::before {
    opacity: 0.8;
    background: linear-gradient(90deg,
            transparent 0%,
            rgba(var(--glow-rgb), 0) 25%,
            rgba(var(--glow-rgb), 0.2) 50%,
            rgba(var(--glow-rgb), 0) 75%,
            transparent 100%);
}

/* Green: WhatsApp */
.glow-wa {
    --glow-rgb: 37, 211, 102;
    border-color: rgba(37, 211, 102, 0.4) !important;
    box-shadow: 0 0 20px rgba(37, 211, 102, 0.1) !important;
}

/* Red: Problem Statement */
.glow-ps {
    --glow-rgb: 236, 72, 153;
    border-color: rgba(236, 72, 153, 0.4) !important;
    box-shadow: 0 0 20px rgba(236, 72, 153, 0.1) !important;
}

/* Blue: PPT Links */
.glow-ppt {
    --glow-rgb: 59, 130, 246;
    border-color: rgba(59, 130, 246, 0.4) !important;
    box-shadow: 0 0 20px rgba(59, 130, 246, 0.1) !important;
}

/* --- Combinations --- */

/* WA + PS (Green + Red) */
.glow-wa-ps {
    border: 1px solid transparent !important;
    background: linear-gradient(var(--glass-bg), var(--glass-bg)) padding-box,
        linear-gradient(to right, rgba(37, 211, 102, 0.4), rgba(236, 72, 153, 0.4)) border-box !important;
    box-shadow: 0 0 20px rgba(37, 211, 102, 0.05), 0 0 20px rgba(236, 72, 153, 0.05) !important;
}

.glow-wa-ps::before {
    background: linear-gradient(90deg,
            transparent 0%,
            rgba(37, 211, 102, 0) 30%,
            rgba(37, 211, 102, 0.07) 45%,
            rgba(236, 72, 153, 0.07) 55%,
            rgba(236, 72, 153, 0) 70%,
            transparent 100%) !important;
}

/* WA + PPT (Green + Blue) */
.glow-wa-ppt {
    border: 1px solid transparent !important;
    background: linear-gradient(var(--glass-bg), var(--glass-bg)) padding-box,
        linear-gradient(to right, rgba(37, 211, 102, 0.4), rgba(59, 130, 246, 0.4)) border-box !important;
    box-shadow: 0 0 20px rgba(37, 211, 102, 0.05), 0 0 20px rgba(59, 130, 246, 0.05) !important;
}

.glow-wa-ppt::before {
    background: linear-gradient(90deg,
            transparent 0%,
            rgba(37, 211, 102, 0) 30%,
            rgba(37, 211, 102, 0.07) 45%,
            rgba(59, 130, 246, 0.07) 55%,
            rgba(59, 130, 246, 0) 70%,
            transparent 100%) !important;
}

/* PS + PPT (Red + Blue) */
.glow-ps-ppt {
    border: 1px solid transparent !important;
    background: linear-gradient(var(--glass-bg), var(--glass-bg)) padding-box,
        linear-gradient(to right, rgba(236, 72, 153, 0.4), rgba(59, 130, 246, 0.4)) border-box !important;
    box-shadow: 0 0 20px rgba(236, 72, 153, 0.05), 0 0 20px rgba(59, 130, 246, 0.05) !important;
}

.glow-ps-ppt::before {
    background: linear-gradient(90deg,
            transparent 0%,
            rgba(236, 72, 153, 0) 30%,
            rgba(236, 72, 153, 0.07) 45%,
            rgba(59, 130, 246, 0.07) 55%,
            rgba(59, 130, 246, 0) 70%,
            transparent 100%) !important;
}

/* THE ULTIMATE GLOW (Tri-color) */
.glow-all {
    border: 1px solid transparent !important;
    background: linear-gradient(var(--glass-bg), var(--glass-bg)) padding-box,
        linear-gradient(to right, rgba(37, 211, 102, 0.4), rgba(236, 72, 153, 0.4), rgba(59, 130, 246, 0.4)) border-box !important;
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.05) !important;
}

.glow-all::before {
    background: linear-gradient(90deg,
            transparent 0%,
            rgba(37, 211, 102, 0) 25%,
            rgba(37, 211, 102, 0.05) 40%,
            rgba(236, 72, 153, 0.05) 50%,
            rgba(59, 130, 246, 0.05) 60%,
            rgba(59, 130, 246, 0) 75%,
            transparent 100%) !important;
    animation-duration: 4s !important;
    /* Faster for the champions */
}

/* Standard status icon styles */

.status-icon-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    color: var(--text-secondary);
    transition: all 0.2s ease;
}

.status-icon-badge.active {
    background: rgba(255, 255, 255, 0.1);
    border-color: var(--accent-color);
    color: var(--accent-color);
}

.status-icon-badge.whatsapp.active {
    color: #25D366;
    border-color: rgba(37, 211, 102, 0.3);
}

.status-icon-badge.ps.active {
    color: #ec4899;
    border-color: rgba(236, 72, 153, 0.3);
}

.status-icon-badge.ppt.active {
    color: #3b82f6;
    border-color: rgba(59, 130, 246, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;;8CAE8C;;AAE9C;IACI,yCAAyC;;IAEzC,gBAAgB;IAChB,6EAA6E;IAC7E,sCAAsC;IACtC,oCAAoC;;IAEpC,gBAAgB;IAChB,qCAAqC;IACrC,yCAAyC;IACzC,wCAAwC;IACxC,qCAAqC;;IAErC,SAAS;IACT,oBAAoB;IACpB,0CAA0C;IAC1C,sCAAsC;IACtC,4DAA4D;;IAE5D,WAAW;IACX,qCAAqC;IACrC,wCAAwC;IACxC,kBAAkB;IAClB,6CAA6C;;IAE7C,YAAY;IACZ,iCAAiC;IACjC,eAAe;IACf,6BAA6B;IAC7B,8CAA8C;;IAE9C,YAAY;IACZ,mDAAmD;IACnD,+CAA+C;AACnD;;AAEA,kCAAkC;AAClC;IACI,yDAAyD;IACzD,gEAAgE;IAChE,gBAAgB;IAChB,yCAAyC;IACzC,mCAAmC;IACnC,gBAAgB;IAChB,mCAAmC;IACnC,aAAa;;IAEb,2CAA2C;IAC3C,oCAAoC;IACpC,kBAAkB;IAClB,mCAAmC;IACnC,uCAAuC;IACvC,wCAAwC;;IAExC,SAAS;IACT,oBAAoB;IACpB,cAAc;IACd,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,cAAc;IACd,+DAA+D;;IAE/D,WAAW;IACX,oCAAoC;IACpC,kCAAkC;IAClC,qBAAqB;IACrB,4BAA4B;;IAE5B,YAAY;IACZ,iCAAiC;IACjC,sCAAsC;IACtC,6BAA6B;IAC7B,wCAAwC;;IAExC,YAAY;IACZ,sFAAsF;IACtF,2CAA2C;;IAE3C,sDAAsD;IACtD,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA;;8CAE8C;;AAE9C;IACI,iBAAiB;IACjB,WAAW;IACX,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,gGAAgG;IAChG,iDAAiD;AACrD;;AAEA,oCAAoC;AACpC;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT;;6EAEyE;IACzE,oBAAoB;IACpB,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;;8CAE8C;;AAE9C;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mCAAmC;IACnC,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;IAC5C,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,8BAA8B;IAC9B,2BAA2B;IAC3B,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;8CAE8C;;AAE9C;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,wBAAwB;IACxB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,2BAA2B;IAC3B,qCAAqC;IACrC,2BAA2B;IAC3B,oBAAoB;IACpB,eAAe;IACf,wBAAwB;IACxB,eAAe;IACf,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;IAC3B,+BAA+B;IAC/B,yCAAyC;IACzC,aAAa;AACjB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,sBAAsB;IACtB,OAAO;IACP,QAAQ;IACR,8BAA8B;IAC9B,2BAA2B;IAC3B,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,2BAA2B;IAC3B,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;;8CAE8C;;AAE9C;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA,+EAA+E;AAC/E;IACI,kBAAkB;IAElB,oFAAoF;AACxF;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,qBAAqB;IACrB,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;;;AAIA;IACI,eAAe;IACf,aAAa,EAAE,8BAA8B;IAC7C,2BAA2B;IAC3B,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,qDAAqD;IACrD,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4DAA4D;IAC5D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,kBAAkB,EAAE,sCAAsC;AAC9D;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;;8CAE8C;;AAE9C;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,qDAAqD;IACrD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;;8CAE8C;;AAE9C;IACI,aAAa;IACb,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,qDAAqD;IACrD,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;iFACiF;AACjF;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,uCAAuC;IACvC,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mFAAmF;IACnF,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,+CAA+C;IAC/C,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA,2BAA2B;AAC3B;IACI;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,mBAAmB;QACnB,yCAAyC;QACzC,2BAA2B;QAC3B,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;;8CAE8C;AAC9C;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,iCAAiC;IACjC,4CAA4C;IAC5C,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,+BAA+B;IAC/B,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;;AAGA;;8CAE8C;AAC9C;IACI,2BAA2B;IAC3B,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;8CAE8C;AAC9C;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA,uBAAuB;IACvB;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,YAA0B;QAA1B,cAA0B;QAA1B,4BAA0B;IAC9B;AACJ;;AAEA;IACI,qDAAqD;IACrD,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;;8CAE8C;;AAE9C;IACI;QACI,0CAA0C;IAC9C;;IAEA;QACI,yCAAyC;IAC7C;AACJ;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,uEAAuE;AAC3E;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,oBAAoB;IACpB,UAAU;IACV,YAAY;AAChB;;AAEA,gCAAgC;AAChC;IACI;;;;;6BAKyB;AAC7B;;AAEA;IACI,YAAY;IACZ;;;;;6BAKyB;AAC7B;;AAEA,oBAAoB;AACpB;IACI,wBAAwB;IACxB,gDAAgD;IAChD,uDAAuD;AAC3D;;AAEA,2BAA2B;AAC3B;IACI,wBAAwB;IACxB,gDAAgD;IAChD,uDAAuD;AAC3D;;AAEA,oBAAoB;AACpB;IACI,wBAAwB;IACxB,gDAAgD;IAChD,uDAAuD;AAC3D;;AAEA,yBAAyB;;AAEzB,0BAA0B;AAC1B;IACI,wCAAwC;IACxC;yGACqG;IACrG,2FAA2F;AAC/F;;AAEA;IACI;;;;;;wCAMoC;AACxC;;AAEA,4BAA4B;AAC5B;IACI,wCAAwC;IACxC;yGACqG;IACrG,2FAA2F;AAC/F;;AAEA;IACI;;;;;;wCAMoC;AACxC;;AAEA,0BAA0B;AAC1B;IACI,wCAAwC;IACxC;yGACqG;IACrG,2FAA2F;AAC/F;;AAEA;IACI;;;;;;wCAMoC;AACxC;;AAEA,kCAAkC;AAClC;IACI,wCAAwC;IACxC;kIAC8H;IAC9H,yDAAyD;AAC7D;;AAEA;IACI;;;;;;;wCAOoC;IACpC,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA,gCAAgC;;AAEhC;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,qCAAqC;IACrC,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,iCAAiC;IACjC,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,qCAAqC;AACzC","sourcesContent":["/* =========================================\n   HOME PAGE DESIGN SYSTEM - Lovable & Modern\n   ========================================= */\n\n:root {\n    /* --- Default Dark Theme Variables --- */\n\n    /* Backgrounds */\n    --bg-gradient: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%);\n    --bg-mesh-1: rgba(120, 119, 198, 0.15);\n    --bg-mesh-2: rgba(67, 56, 202, 0.15);\n\n    /* Glass/Cards */\n    --glass-bg: rgba(255, 255, 255, 0.03);\n    --glass-border: rgba(255, 255, 255, 0.08);\n    --glass-hover: rgba(255, 255, 255, 0.08);\n    --dropdown-bg: rgba(30, 41, 59, 0.95);\n\n    /* Text */\n    --text-main: #ffffff;\n    --text-secondary: rgba(255, 255, 255, 0.7);\n    --text-muted: rgba(255, 255, 255, 0.5);\n    --heading-gradient: linear-gradient(to right, #fff, #94a3b8);\n\n    /* Inputs */\n    --input-bg: rgba(255, 255, 255, 0.08);\n    --input-border: rgba(255, 255, 255, 0.1);\n    --input-text: #fff;\n    --input-placeholder: rgba(255, 255, 255, 0.4);\n\n    /* Accents */\n    --accent-color: hsl(38, 92%, 50%);\n    /* Gold/Amber */\n    --primary: hsl(197, 71%, 28%);\n    --decorative-circle: rgba(255, 255, 255, 0.05);\n\n    /* Shadows */\n    --shadow-card: 0 10px 30px -10px rgba(0, 0, 0, 0.5);\n    --shadow-glow: 0 0 20px rgba(79, 70, 229, 0.15);\n}\n\n/* --- Light Theme Variables --- */\n[data-theme='light'] {\n    /* Bright, Attracting Gradient: Soft Warmth + Fresh Air */\n    --bg-gradient: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);\n    /* Clean Cloud */\n    /* Alternative \"Attracting\" Mesh colors */\n    --bg-mesh-1: rgba(255, 165, 0, 0.1);\n    /* Soft Orange */\n    --bg-mesh-2: rgba(0, 191, 255, 0.1);\n    /* Sky Blue */\n\n    /* Glass/Cards - Darker glass on light bg */\n    --glass-bg: rgba(255, 255, 255, 0.7);\n    /* Frosted White */\n    --glass-border: rgba(0, 0, 0, 0.12);\n    --glass-hover: rgba(255, 255, 255, 0.9);\n    --dropdown-bg: rgba(255, 255, 255, 0.95);\n\n    /* Text */\n    --text-main: #1e293b;\n    /* Slate 800 */\n    --text-secondary: #475569;\n    /* Slate 600 */\n    --text-muted: #94a3b8;\n    /* Slate 400 */\n    --heading-gradient: linear-gradient(to right, #0f172a, #334155);\n\n    /* Inputs */\n    --input-bg: rgba(255, 255, 255, 0.8);\n    --input-border: rgba(0, 0, 0, 0.1);\n    --input-text: #0f172a;\n    --input-placeholder: #94a3b8;\n\n    /* Accents */\n    --accent-color: hsl(38, 95%, 45%);\n    /* Slightly darker gold for contrast */\n    --primary: hsl(197, 71%, 35%);\n    --decorative-circle: rgba(0, 0, 0, 0.03);\n\n    /* Shadows */\n    --shadow-card: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);\n    --shadow-glow: 0 0 15px rgba(0, 0, 0, 0.05);\n\n    /* Specific Overrides for Icon Buttons in Light Mode */\n    --btn-bg: rgba(0, 0, 0, 0.05);\n    --btn-hover: rgba(0, 0, 0, 0.1);\n}\n\n/* =========================================\n   LAYOUT & CONTAINER\n   ========================================= */\n\n.home-page-container {\n    min-height: 100vh;\n    width: 100%;\n    background: var(--bg-gradient);\n    color: var(--text-main);\n    position: relative;\n    overflow-x: hidden;\n    padding-bottom: 4rem;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    transition: background 0.5s ease, color 0.3s ease;\n}\n\n/* Subtle Animated Background Mesh */\n.home-page-container::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background:\n        radial-gradient(circle at 15% 50%, var(--bg-mesh-1), transparent 25%),\n        radial-gradient(circle at 85% 30%, var(--bg-mesh-2), transparent 25%);\n    pointer-events: none;\n    z-index: 0;\n    transition: background 0.5s ease;\n}\n\n.home-content-wrapper {\n    position: relative;\n    z-index: 10;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    gap: 2.5rem;\n}\n\n/* =========================================\n   HEADER & NAV\n   ========================================= */\n\n.home-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem 0;\n}\n\n.brand-section {\n    display: flex;\n    flex-direction: column;\n}\n\n.brand-title {\n    font-size: 1.5rem;\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    background: var(--heading-gradient);\n    -webkit-background-clip: text;\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.greeting-text {\n    font-size: 0.9rem;\n    color: var(--text-secondary);\n    font-weight: 500;\n}\n\n.header-actions {\n    display: flex;\n    gap: 0.75rem;\n}\n\n.icon-btn {\n    width: 40px;\n    height: 40px;\n    border-radius: 12px;\n    background: var(--glass-bg);\n    border: 1px solid var(--glass-border);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-main);\n    cursor: pointer;\n    transition: all 0.2s ease;\n    position: relative;\n}\n\n[data-theme='light'] .icon-btn {\n    background: white;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.icon-btn:hover {\n    background: var(--glass-hover);\n    transform: translateY(-2px);\n}\n\n.notification-badge {\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    width: 10px;\n    height: 10px;\n    background: #ef4444;\n    border-radius: 50%;\n    border: 2px solid var(--background, #1a1a2e);\n    /* Fallback */\n}\n\n/* Notif Dropdown */\n.notifications-dropdown {\n    position: absolute;\n    top: 105%;\n    right: 0;\n    width: 300px;\n    background: var(--dropdown-bg);\n    backdrop-filter: blur(12px);\n    border: 1px solid var(--glass-border);\n    border-radius: 16px;\n    padding: 1rem;\n    box-shadow: var(--shadow-card);\n    z-index: 100;\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n    color: var(--text-main);\n}\n\n.notif-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.8rem;\n    background: var(--glass-bg);\n    border-radius: 8px;\n    font-size: 0.9rem;\n}\n\n.btn-accept {\n    background: var(--primary);\n    border: none;\n    color: white;\n    padding: 0.4rem 0.8rem;\n    border-radius: 6px;\n    font-size: 0.8rem;\n    cursor: pointer;\n}\n\n/* =========================================\n   SEARCH SECTION\n   ========================================= */\n\n.search-section {\n    display: flex;\n    justify-content: center;\n    position: relative;\n    z-index: 50;\n}\n\n.search-pill-container {\n    width: 100%;\n    max-width: 600px;\n    position: relative;\n}\n\n.search-input-group {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.search-icon {\n    position: absolute;\n    left: 1.25rem;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--text-muted);\n    pointer-events: none;\n    z-index: 10;\n}\n\n.search-input-modern {\n    width: 100%;\n    padding: 1rem 1rem 1rem 3.5rem;\n    background: var(--input-bg);\n    border: 1px solid var(--input-border);\n    backdrop-filter: blur(10px);\n    border-radius: 10rem;\n    /* Pill shape */\n    color: var(--input-text);\n    font-size: 1rem;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n}\n\n.search-input-modern:focus {\n    background: var(--input-bg);\n    border-color: var(--text-muted);\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);\n    outline: none;\n}\n\n.search-input-modern::placeholder {\n    color: var(--input-placeholder);\n}\n\n.no-results-text {\n    padding: 2rem;\n    text-align: center;\n    color: var(--text-muted);\n    font-size: 0.95rem;\n    width: 100%;\n    font-weight: 500;\n}\n\n/* Search Results Dropdown */\n.search-results-glass {\n    position: absolute;\n    top: calc(100% + 12px);\n    left: 0;\n    right: 0;\n    background: var(--dropdown-bg);\n    backdrop-filter: blur(16px);\n    border: 1px solid var(--glass-border);\n    border-radius: 16px;\n    padding: 0.5rem;\n    max-height: 400px;\n    overflow-y: auto;\n    box-shadow: var(--shadow-card);\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n    color: var(--text-main);\n}\n\n.search-result-row {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    padding: 0.75rem 1rem;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: background 0.2s;\n    text-decoration: none;\n    color: var(--text-main);\n    background: transparent;\n    border: none;\n    width: 100%;\n    font-family: inherit;\n    font-size: 0.95rem;\n}\n\n.search-result-row:hover {\n    background: var(--glass-hover);\n}\n\n.result-avatar-small {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: var(--primary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 0.9rem;\n    color: white;\n}\n\n.result-info {\n    display: flex;\n    flex-direction: column;\n}\n\n.result-name {\n    font-weight: 600;\n    font-size: 0.95rem;\n    color: var(--text-main);\n}\n\n.result-meta {\n    font-size: 0.8rem;\n    color: var(--text-muted);\n}\n\n/* =========================================\n   SUGGESTIONS CAROUSEL\n   ========================================= */\n\n.suggestions-section {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.section-title {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: var(--text-main);\n    padding-left: 0.5rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n/* Standard Scrollable Suggestions which will be driven by JS for auto-scroll */\n.suggestions-track-wrapper {\n    position: relative;\n    -webkit-mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);\n    mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);\n}\n\n.suggestions-carousel {\n    display: flex;\n    gap: 1rem;\n    overflow-x: auto;\n    padding: 1rem 0.5rem;\n    scrollbar-width: none;\n    cursor: grab;\n    scroll-behavior: auto;\n    -webkit-overflow-scrolling: touch;\n    touch-action: pan-x;\n}\n\n.suggestions-carousel::-webkit-scrollbar {\n    display: none;\n}\n\n\n\n.suggestion-card-modern {\n    flex: 0 0 200px;\n    height: 220px; /* Enforce consistent height */\n    background: var(--glass-bg);\n    border: 1px solid var(--glass-border);\n    border-radius: 16px;\n    padding: 1.25rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.75rem;\n    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n    text-decoration: none;\n    position: relative;\n    overflow: hidden;\n}\n\n[data-theme='light'] .suggestion-card-modern {\n    background: white;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);\n}\n\n.suggestion-card-modern:hover {\n    background: var(--glass-hover);\n    transform: translateY(-5px);\n    box-shadow: var(--shadow-card);\n    border-color: var(--glass-border);\n}\n\n.sugg-avatar-large {\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, var(--primary), #9333ea);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: white;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.sugg-info {\n    text-align: center;\n}\n\n.sugg-name {\n    font-weight: 700;\n    color: var(--text-main);\n    font-size: 1rem;\n    line-height: 1.25;\n    margin-bottom: 0.5rem;\n    white-space: normal;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n    min-height: 2.5rem; /* Reserve space for up to two lines */\n}\n\n.sugg-dept {\n    font-size: 0.8rem;\n    color: var(--text-secondary);\n    background: var(--glass-border);\n    padding: 0.2rem 0.6rem;\n    border-radius: 20px;\n}\n\n.connect-btn-mini {\n    margin-top: 0.25rem;\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: var(--accent-color);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n/* =========================================\n   UTILITIES\n   ========================================= */\n\n.glass-card {\n    background: var(--glass-bg);\n    backdrop-filter: blur(12px);\n    border: 1px solid var(--glass-border);\n    border-radius: 20px;\n    padding: 1.5rem;\n    color: var(--text-main);\n    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n    position: relative;\n    overflow: hidden;\n}\n\n[data-theme='light'] .glass-card {\n    background: white;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n}\n\n/* =========================================\n   BENTO GRID FEATURES\n   ========================================= */\n\n.features-grid-bento {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n}\n\n@media (min-width: 768px) {\n    .features-grid-bento {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n.feature-tile {\n    background: var(--glass-bg);\n    backdrop-filter: blur(10px);\n    border: 1px solid var(--glass-border);\n    border-radius: 24px;\n    padding: 2rem;\n    text-decoration: none;\n    color: var(--text-main);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    /* Center content */\n    gap: 1.5rem;\n    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n    position: relative;\n    overflow: hidden;\n    min-height: 200px;\n}\n\n[data-theme='light'] .feature-tile {\n    background: white;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);\n}\n\n/* Specific styling for larger primary card if we want odd layouts, \n   but 3-col grid is clean. Let's make the \"Profile\" card span 2 cols on tablet */\n@media (min-width: 768px) and (max-width: 1024px) {\n    .feature-tile:first-child {\n        grid-column: span 2;\n    }\n}\n\n.feature-tile:hover {\n    background: var(--glass-hover);\n    transform: translateY(-5px) scale(1.02);\n    border-color: var(--glass-border);\n    box-shadow: var(--shadow-card);\n}\n\n.tile-icon-box {\n    width: 80px;\n    height: 80px;\n    border-radius: 24px;\n    background: linear-gradient(135deg, var(--glass-border), rgba(255, 255, 255, 0.02));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 0.5rem;\n    box-shadow: inset 0 0 0 1px var(--glass-border);\n    transition: transform 0.3s ease;\n    color: var(--text-main);\n}\n\n[data-theme='light'] .tile-icon-box {\n    background: #f1f5f9;\n}\n\n.feature-tile:hover .tile-icon-box {\n    transform: scale(1.1) rotate(5deg);\n}\n\n.tile-content {\n    text-align: center;\n}\n\n.tile-title {\n    font-size: 1.5rem;\n    font-weight: 700;\n    margin-bottom: 0.5rem;\n    color: var(--text-main);\n}\n\n.tile-desc {\n    font-size: 0.9rem;\n    color: var(--text-secondary);\n    line-height: 1.4;\n}\n\n/* Decorative Circle */\n.feature-tile-bg-circle {\n    position: absolute;\n    top: -20%;\n    right: -20%;\n    width: 150px;\n    height: 150px;\n    background: var(--decorative-circle);\n    border-radius: 50%;\n    pointer-events: none;\n}\n\n/* Responsive adjustments */\n@media (max-width: 640px) {\n    .home-content-wrapper {\n        padding: 1rem;\n        gap: 2rem;\n    }\n\n    .brand-title {\n        font-size: 1.25rem;\n    }\n\n    .feature-tile {\n        min-height: 160px;\n        padding: 1.5rem;\n        flex-direction: row;\n        /* Horizontal on mobile for compactness */\n        justify-content: flex-start;\n        text-align: left;\n        align-items: center;\n    }\n\n    .tile-icon-box {\n        width: 60px;\n        height: 60px;\n        margin-bottom: 0;\n        flex-shrink: 0;\n    }\n\n    .tile-content {\n        text-align: left;\n    }\n\n    .tile-desc {\n        font-size: 0.85rem;\n    }\n}\n\n/* =========================================\n   MEMBER DOTS (Formation)\n   ========================================= */\n.member-dot {\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    background: var(--primary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid var(--glass-border);\n    transition: all 0.2s ease;\n    overflow: hidden;\n    color: white;\n    font-weight: bold;\n    font-size: 0.8rem;\n}\n\n.member-dot:hover {\n    transform: scale(1.1);\n    border-color: var(--accent-color);\n    box-shadow: 0 0 10px rgba(59, 130, 246, 0.3);\n    z-index: 10;\n}\n\n.member-dot img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.member-dot-empty {\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    background: transparent;\n    border: 2px dashed rgba(255, 255, 255, 0.2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: rgba(255, 255, 255, 0.3);\n}\n\n.status-badge-open {\n    background: rgba(34, 197, 94, 0.2);\n    color: #22c55e;\n    padding: 0.2rem 0.6rem;\n    border-radius: 12px;\n    font-size: 0.8rem;\n    font-weight: bold;\n    border: 1px solid rgba(34, 197, 94, 0.3);\n}\n\n.lead-badge {\n    background: var(--accent-color);\n    color: var(--background);\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-size: 0.7rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    margin-left: 0.5rem;\n}\n\n\n/* =========================================\n   TEAM ROOM REDESIGN (Premium Cards)\n   ========================================= */\n.member-info-card {\n    background: var(--glass-bg);\n    border: 1px solid var(--glass-border);\n    border-radius: 20px;\n    padding: 1.5rem;\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n    position: relative;\n    transition: all 0.3s ease;\n}\n\n[data-theme='light'] .member-info-card {\n    background: white;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n}\n\n.member-avatar-box {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    overflow: hidden;\n    flex-shrink: 0;\n    border: 3px solid var(--glass-border);\n    background: var(--primary);\n}\n\n.member-avatar-box img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.rule-item {\n    margin-bottom: 1.25rem;\n}\n\n.rule-label {\n    font-size: 0.9rem;\n    font-weight: 500;\n    margin-bottom: 0.5rem;\n    display: block;\n}\n\n.rule-progress {\n    height: 8px;\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 10px;\n    overflow: hidden;\n}\n\n[data-theme='dark'] .rule-progress {\n    background: rgba(255, 255, 255, 0.1);\n}\n\n.rule-progress-bar {\n    height: 100%;\n    background: var(--accent-color);\n    border-radius: 10px;\n    transition: width 0.5s ease;\n}\n\n.rule-item.success .rule-progress-bar {\n    background: #22c55e;\n}\n\n/* =========================================\n   TEAM ROOM RESPONSIVE LAYOUT\n   ========================================= */\n.team-room-header-stats {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4rem;\n}\n\n.team-room-grid {\n    display: grid;\n    grid-template-columns: 1fr 350px;\n    gap: 2rem;\n}\n\n.header-card-main {\n    padding: 3.5rem 2rem;\n    margin-bottom: 2rem;\n    text-align: center;\n    border-radius: 30px !important;\n}\n\n.team-name-title {\n    font-size: 4rem;\n    margin-bottom: 1rem;\n    line-height: 1.1;\n}\n\n.team-members-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1.5rem;\n}\n\n@media (max-width: 1024px) {\n    .team-room-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 768px) {\n    .team-room-header-stats {\n        gap: 1.5rem;\n        flex-wrap: wrap;\n    }\n\n    .team-members-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .member-info-card {\n        padding: 1rem;\n        gap: 1rem;\n    }\n\n    .member-avatar-box {\n        width: 60px;\n        height: 60px;\n    }\n\n    /* Header refinements */\n    .team-name-title {\n        font-size: 1.8rem !important;\n    }\n\n    .header-card-main {\n        padding: 2rem 1rem !important;\n    }\n}\n\n@media (max-width: 480px) {\n    .team-room-header-stats {\n        gap: 1rem;\n    }\n\n    .team-room-header-stats>div {\n        flex: 0 0 calc(50% - 1rem);\n    }\n}\n\n.hover-underline:hover {\n    text-decoration-color: var(--accent-color) !important;\n    color: var(--accent-color);\n}\n\n.hover-bg-glass:hover {\n    background: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme='light'] .member-dot-empty {\n    border-color: rgba(0, 0, 0, 0.2);\n    color: rgba(0, 0, 0, 0.4);\n}\n\n[data-theme='light'] .status-badge-open {\n    background: rgba(16, 185, 129, 0.1);\n    color: #059669;\n    border: 1px solid rgba(16, 185, 129, 0.2);\n}\n\n/* =========================================\n   DYNAMIC MULTI-COLOR GLOW SYSTEM\n   ========================================= */\n\n@keyframes glassGlow {\n    0% {\n        transform: translateX(-150%) skewX(-20deg);\n    }\n\n    100% {\n        transform: translateX(250%) skewX(-20deg);\n    }\n}\n\n.team-card-glow {\n    position: relative !important;\n    overflow: hidden !important;\n    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;\n}\n\n.team-card-glow::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    animation: glassGlow 6s infinite linear;\n    pointer-events: none;\n    z-index: 1;\n    opacity: 0.6;\n}\n\n/* Base Shine Gradient Utility */\n.team-card-glow::before {\n    background: linear-gradient(90deg,\n            transparent 0%,\n            rgba(var(--glow-rgb), 0) 30%,\n            rgba(var(--glow-rgb), 0.15) 50%,\n            rgba(var(--glow-rgb), 0) 70%,\n            transparent 100%);\n}\n\n[data-theme='light'] .team-card-glow::before {\n    opacity: 0.8;\n    background: linear-gradient(90deg,\n            transparent 0%,\n            rgba(var(--glow-rgb), 0) 25%,\n            rgba(var(--glow-rgb), 0.2) 50%,\n            rgba(var(--glow-rgb), 0) 75%,\n            transparent 100%);\n}\n\n/* Green: WhatsApp */\n.glow-wa {\n    --glow-rgb: 37, 211, 102;\n    border-color: rgba(37, 211, 102, 0.4) !important;\n    box-shadow: 0 0 20px rgba(37, 211, 102, 0.1) !important;\n}\n\n/* Red: Problem Statement */\n.glow-ps {\n    --glow-rgb: 236, 72, 153;\n    border-color: rgba(236, 72, 153, 0.4) !important;\n    box-shadow: 0 0 20px rgba(236, 72, 153, 0.1) !important;\n}\n\n/* Blue: PPT Links */\n.glow-ppt {\n    --glow-rgb: 59, 130, 246;\n    border-color: rgba(59, 130, 246, 0.4) !important;\n    box-shadow: 0 0 20px rgba(59, 130, 246, 0.1) !important;\n}\n\n/* --- Combinations --- */\n\n/* WA + PS (Green + Red) */\n.glow-wa-ps {\n    border: 1px solid transparent !important;\n    background: linear-gradient(var(--glass-bg), var(--glass-bg)) padding-box,\n        linear-gradient(to right, rgba(37, 211, 102, 0.4), rgba(236, 72, 153, 0.4)) border-box !important;\n    box-shadow: 0 0 20px rgba(37, 211, 102, 0.05), 0 0 20px rgba(236, 72, 153, 0.05) !important;\n}\n\n.glow-wa-ps::before {\n    background: linear-gradient(90deg,\n            transparent 0%,\n            rgba(37, 211, 102, 0) 30%,\n            rgba(37, 211, 102, 0.07) 45%,\n            rgba(236, 72, 153, 0.07) 55%,\n            rgba(236, 72, 153, 0) 70%,\n            transparent 100%) !important;\n}\n\n/* WA + PPT (Green + Blue) */\n.glow-wa-ppt {\n    border: 1px solid transparent !important;\n    background: linear-gradient(var(--glass-bg), var(--glass-bg)) padding-box,\n        linear-gradient(to right, rgba(37, 211, 102, 0.4), rgba(59, 130, 246, 0.4)) border-box !important;\n    box-shadow: 0 0 20px rgba(37, 211, 102, 0.05), 0 0 20px rgba(59, 130, 246, 0.05) !important;\n}\n\n.glow-wa-ppt::before {\n    background: linear-gradient(90deg,\n            transparent 0%,\n            rgba(37, 211, 102, 0) 30%,\n            rgba(37, 211, 102, 0.07) 45%,\n            rgba(59, 130, 246, 0.07) 55%,\n            rgba(59, 130, 246, 0) 70%,\n            transparent 100%) !important;\n}\n\n/* PS + PPT (Red + Blue) */\n.glow-ps-ppt {\n    border: 1px solid transparent !important;\n    background: linear-gradient(var(--glass-bg), var(--glass-bg)) padding-box,\n        linear-gradient(to right, rgba(236, 72, 153, 0.4), rgba(59, 130, 246, 0.4)) border-box !important;\n    box-shadow: 0 0 20px rgba(236, 72, 153, 0.05), 0 0 20px rgba(59, 130, 246, 0.05) !important;\n}\n\n.glow-ps-ppt::before {\n    background: linear-gradient(90deg,\n            transparent 0%,\n            rgba(236, 72, 153, 0) 30%,\n            rgba(236, 72, 153, 0.07) 45%,\n            rgba(59, 130, 246, 0.07) 55%,\n            rgba(59, 130, 246, 0) 70%,\n            transparent 100%) !important;\n}\n\n/* THE ULTIMATE GLOW (Tri-color) */\n.glow-all {\n    border: 1px solid transparent !important;\n    background: linear-gradient(var(--glass-bg), var(--glass-bg)) padding-box,\n        linear-gradient(to right, rgba(37, 211, 102, 0.4), rgba(236, 72, 153, 0.4), rgba(59, 130, 246, 0.4)) border-box !important;\n    box-shadow: 0 0 30px rgba(255, 255, 255, 0.05) !important;\n}\n\n.glow-all::before {\n    background: linear-gradient(90deg,\n            transparent 0%,\n            rgba(37, 211, 102, 0) 25%,\n            rgba(37, 211, 102, 0.05) 40%,\n            rgba(236, 72, 153, 0.05) 50%,\n            rgba(59, 130, 246, 0.05) 60%,\n            rgba(59, 130, 246, 0) 75%,\n            transparent 100%) !important;\n    animation-duration: 4s !important;\n    /* Faster for the champions */\n}\n\n/* Standard status icon styles */\n\n.status-icon-badge {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border-radius: 8px;\n    background: var(--glass-bg);\n    border: 1px solid var(--glass-border);\n    color: var(--text-secondary);\n    transition: all 0.2s ease;\n}\n\n.status-icon-badge.active {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: var(--accent-color);\n    color: var(--accent-color);\n}\n\n.status-icon-badge.whatsapp.active {\n    color: #25D366;\n    border-color: rgba(37, 211, 102, 0.3);\n}\n\n.status-icon-badge.ps.active {\n    color: #ec4899;\n    border-color: rgba(236, 72, 153, 0.3);\n}\n\n.status-icon-badge.ppt.active {\n    color: #3b82f6;\n    border-color: rgba(59, 130, 246, 0.3);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
